import React, {Component} from 'react';
import App from "../../App";
import {Link, withRouter} from "react-router-dom";
import "../../assets/scss/order-list.scss";
import ExportCSVAsync from "../common/ExportCSVAsync";
import {getFormattedDate} from "../../helper/utils";
import DatePicker from "react-datepicker";
import {Button} from "react-bootstrap";
import {getPaginatedList} from "../../services/baseServices";
import Pagination from "react-js-pagination";
import Loader from 'react-loader';
import {FaLongArrowAltLeft} from "react-icons/all";

const headers = [
    {label: "MONTHS", key: "months"},
    {label: "DH TOTAL COLLECTION", key: "fc_total_collection"},
    {label: "DH COMMISSION", key: "fc_commission"},
    {label: "SUB AGENT COMMISSION", key: "sub_agent_commission"}
];

var today = new Date()
var futureDate = new Date()
today.setMonth(today.getMonth() - 1)
futureDate.setMonth(futureDate.getMonth() - 1)
futureDate.setFullYear(futureDate.getFullYear() + 1)

const loadData = (item) => {
    return {
        months: item.months,
        fc_total_collection: item.fc_total_collection,
        fc_commission: item.fc_commission,
        sub_agent_commission: item.sub_agent_commission,
    };
};

class List extends Component {
    constructor() {
        super();
        this.state = {
            list: [],
            isLoading: true,
            activePage: 1,
            per_page: 15,
            page: 1,
            temp_params: {
                start_month: today.getMonth() + 1,
                start_year: today.getFullYear(),
                end_month: futureDate.getMonth() + 1,
                end_year: futureDate.getFullYear()
            },
            query_params: {
                start_month: today.getMonth() + 1,
                start_year: today.getFullYear(),
                end_month: futureDate.getMonth() + 1,
                end_year: futureDate.getFullYear()
            },
            isExporting: false,
            start_date: today,
            end_date: futureDate,
            total_fc_collection: 0,
            total_fc_commission: 0,
            total_partner_commission: 0
        };
    }

    getQueryParams = () => {
        let params = Object.assign(this.state.query_params, {
            per_page: this.state.per_page,
            page: this.state.page,
            skip_pagination: false
        });
        return params;
    }

    getPaginatedPOs = (params) => {
        this.setState({...this.state, isLoading: true});
        getPaginatedList("payment_histories", {...params, ...{distributor_id: this.props.match.params.id}})
            .then(res => {
                this.setState({
                    list: res?.data?.payment_histories,
                    total_fc_collection: res?.data.total_fc_collection,
                    total_fc_commission: res?.data.total_fc_commission,
                    total_partner_commission: res?.data.total_partner_commission,
                    isLoading: false,
                    per_page: res.headers['x-per-page'],
                    total_data: res.headers['x-total'],
                }, () => {
                });
            })
            .catch(errMsg => {
                this.setState({...this.state, isLoading: false});
                console.log('Error Message: ', errMsg)
            })
    }

    componentDidMount() {
        this.getPaginatedPOs(this.getQueryParams());
    }

    handlePageChange = (pageNumber) => {
        this.setState({page: pageNumber, activePage: pageNumber}, () => {
            this.getPaginatedPOs(this.getQueryParams());
        });
    }

    handleOnSearch = (e) => {
        e.preventDefault();
        const tempParam = this.state.temp_params;
        console.log(tempParam)
        this.setState({...this.state, page: 1, query_params: tempParam}, () => {
            this.getPaginatedPOs(this.state.temp_params);
        });
    }

    handleOnApplyFrom = (date) => {
        if (date) {
            this.setState({start_date: date})
            this.setState({
                temp_params: {
                    ...this.state.temp_params,
                    start_month: date.getMonth() + 1,
                    start_year: date.getFullYear()
                }
            })
        }
    }

    handleOnApplyEnd = (date) => {
        if (date) {
            this.setState({end_date: date})
            this.setState({
                temp_params: {
                    ...this.state.temp_params,
                    end_month: date.getMonth() + 1,
                    end_year: date.getFullYear()
                }
            })
        }
    }

    render() {
        return (
            <App layout="">
                <div className="main-content">
                    <div className="page-header">
                        <h2 className="page-title">Distribution Collection List</h2>
                        <div className="ml-auto d-flex">
                            <Link to={`/dh/list`}
                                  className="btn btn-sm btn-link"><FaLongArrowAltLeft/> Back to List</Link>
                            <ExportCSVAsync
                                fileName={
                                    "DCL-" + getFormattedDate(new Date(), "DD-MM-YYYY") + ".csv"
                                }
                                Url="payment_histories"
                                headers={headers}
                                params={{...this.state.query_params, skip_pagination: true}}
                                loadData={loadData}
                                title="Distribution Collection List"
                            />
                        </div>
                    </div>

                    <form className="form-inline mb-3">
                        <div className="form-group mr-3">
                            <label htmlFor="status" className="sr-only">
                                Date Range
                            </label>
                            <DatePicker
                                required
                                className="form-control"
                                selected={this.state.start_date}
                                onChange={this.handleOnApplyFrom}
                                maxDate={this.state.end_date}
                                dateFormat="MMMM-yyyy"
                                showMonthYearPicker
                                showFullMonthYearPicker
                                showFourColumnMonthYearPicker
                            />
                            &nbsp;
                            <DatePicker
                                className="form-control"
                                selected={this.state.end_date}
                                onChange={this.handleOnApplyEnd}
                                minDate={this.state.start_date}
                                dateFormat="MMMM-yyyy"
                                showMonthYearPicker
                                showFullMonthYearPicker
                                showFourColumnMonthYearPicker
                            />
                        </div>
                        <Button
                            size="sm"
                            type={`submit`}
                            onClick={this.handleOnSearch}
                            variant="primary"
                        >
                            Filter
                        </Button>
                    </form>

                    <Loader loaded={!this.state.isLoading}>
                        <div className="card-block">
                            <div className="block-body">
                                <table className="order-table table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Months</th>
                                        <th>DH Total Collection</th>
                                        <th>DH Commission</th>
                                        <th>Sub agent Commission</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.list?.length > 0 ? this.state.list?.map((item, index) => {
                                        return (
                                            <>
                                                <tr key={index}>
                                                    <td>
                                                        <div className="order-item">
                                                            {item.month_and_year  || '_'}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {item.fc_total_collection || 0}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {item.fc_commission || 0}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {item.partner_commission || 0}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    }) : (
                                        <tr>
                                            <td colSpan={4} className="text-center">
                                                {" "}
                                                <h5>No Order Found</h5>
                                            </td>
                                        </tr>
                                    )}
                                    {this.state.list?.length > 0 &&
                                    <tr>
                                        <td>Total:</td>
                                        <td>
                                            <div className="order-item">
                                                {this.state.total_fc_collection}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="order-item">
                                                {this.state.total_fc_commission}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="order-item">
                                                {this.state.total_partner_commission}
                                            </div>
                                        </td>
                                    </tr>
                                    }
                                    </tbody>
                                </table>
                            </div>
                            <div className="mt-3">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={this.state.per_page}
                                    totalItemsCount={this.state.total_data}
                                    pageRangeDisplayed={10}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div>
                        </div>
                    </Loader>
                </div>
            </App>
        );
    }
}

export default withRouter(List);
